export async function mountIslands(root, registry, mount) {
  const elements = root.querySelectorAll('[data-island]')
  for (const el of elements) {
    const name = el.dataset.island
    const loader = registry[name]
    if (!loader) continue
    const Component = await loader()
    const props = el.dataset.props ? JSON.parse(el.dataset.props) : {}
    mount(Component, props, el)
  }
}

// Turbo swaps in a fresh <body> from the server, which still carries
// v-cloak. A visit fires turbo:render and then turbo:load, but a failed form
// submission (the 422 from /login) fires only turbo:render. Both events call
// this, so each new body is mounted once and then shown.
const revealed = new WeakSet()

export async function revealBody(body, registry, mount) {
  if (!body.hasAttribute('v-cloak') || revealed.has(body)) return
  revealed.add(body)
  await mountIslands(body, registry, mount)
  body.removeAttribute('v-cloak')
}
